import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas, Button } from "react-bootstrap";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      <Offcanvas.Header className="custom-cart-header d-flex justify-content-between align-items-center">
        <Offcanvas.Title >
          YOUR BAG
        </Offcanvas.Title>
        <span
          className="custom-cart-close"
          data-bs-dismiss="offcanvas"
        />
      </Offcanvas.Header>
        <hr className="custom-cart-divider" />
      <Offcanvas.Body className="custom-cart-items overflow-hidden d-flex flex-column">
        {cartItems && cartItems.length ? (
          <>
            <div className="d-flex justify-content-center overflow-y-auto">
              {cartItems && cartItems.length > 0 && (
                <div >
                  {cartItems.map((item, index) => (
                    <CartItems key={item._id || index} item={item} />
                  ))}
                </div>
              )}
            </div>

            <div className="custom-cart-footer mt-auto">
              
      

              <div className="d-flex justify-content-between ">
                <span className="custom-cart-subtotal-label">TOTAL:</span>
                <span className="custom-cart-subtotal-value">₹{cartSummary.total}</span>
              </div>

              <Link
                to="/cart"
                className="custom-cart-btn-view btn w-100"
              >
                GO TO CART
              </Link>
            </div>
          </>
        ) : (
          <div className="tf-mini-cart-wrap-blank">
            <div className="emptycart">
              <span>Your Shopping Cart is Empty</span>
            </div>

            <Link
              to="/shop"
              className="mt-3 tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
            >
              Shop Now
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;
